import { useLocation } from "@/contexts/LocationContext";
import StoreCard from "@/components/stores/StoreCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

const NearbyStores = () => {
  const { nearbyStores, isLoadingStores } = useLocation();
  const openStores = nearbyStores.filter((s) => s.isOpen).slice(0, 5);

  return (
    <section className="py-14 bg-background">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold">📍 Stores Near You</h2>
            <p className="text-muted-foreground text-sm mt-1">Fastest delivery from neighbourhood stores</p>
          </div>
          <Link
            to="/stores"
            className="text-sm font-semibold text-primary flex items-center gap-1 hover:gap-2 transition-all"
          >
            View All <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {isLoadingStores ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-40 rounded-2xl" />
            ))}
          </div>
        ) : openStores.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {openStores.map((store, i) => (
              <StoreCard key={store.id} store={store} index={i} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground text-center py-8">No open stores nearby yet.</p>
        )}
      </div>
    </section>
  );
};

export default NearbyStores;
